import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { InputLabel, Select } from '@material-ui/core';

export const MuiDropdown = ({ inputLabel, labelId, dropdownClassName, dropdownVariant, dropdownValue, onChange, options, disabled = false }) => {
  return (
    <Fragment>
      <InputLabel id={labelId}>{inputLabel}</InputLabel>
      <Select
        className={`Dropdown ${!!dropdownClassName ? dropdownClassName : ''}`}
        variant={dropdownVariant}
        labelId={labelId}
        value={dropdownValue}
        onChange={onChange}
        disabled={disabled}>
        {options}
      </Select>
    </Fragment>
  );
};

MuiDropdown.propTypes = {
  inputLabel: PropTypes.string,
  inputLabelId: PropTypes.string,
  dropdownClassName: PropTypes.string,
  dropdownVariant: PropTypes.string,
  dropdownLabelId: PropTypes.string,
  dropdownValue: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  disabled: PropTypes.bool,
};